<template>
  <CustomCreateDialog
    dialogTitle="اتمام کلاس گروهی"
    :dialogId="`finish-group-class-confirmation-dialog-${dialogId}`"
    okTitle="اتمام کلاس"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendFinishGroupClassRequest"
  >
    <BCol cols="12">
      <p>آیا از اتمام کلاس گروهی اطمینان دارید؟</p>
    </BCol>
  </CustomCreateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    selectedGroupClass: {
      type: Object,
    },
    dialogId: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async sendFinishGroupClassRequest() {
      try {
        this.isOkButtonDisabled = true;
        const _this = this;
        const finishGroupClass = new FinishGroupClass(_this);
        finishGroupClass.setRequestParam({
          groupClassMasterId: _this.selectedGroupClass.id,
        });
        await finishGroupClass.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "به پایان رسید!",
                icon: "CheckIcon",
                variant: "success",
                text: "کلاس گروهی با موفقیت به پایان رسید.",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide(
              `finish-group-class-confirmation-dialog-${this.dialogId}`
            );
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "به پایان نرسید!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomCreateDialog,
    BCol,
  },
};
import CustomCreateDialog from "@/views/components/Utils/Dialogs/CustomCreateDialog.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { FinishGroupClass } from "@/libs/Api/GroupClass";
</script>
